import Vue from 'vue';
import VueRouter from 'vue-router';
import HomePage from '../pages/HomePage.vue';
import RulePage from '../pages/RulePage.vue';
import BusinessPage from "../pages/business/FormPage.vue";
import ResultPage from "../pages/business/ResultPage.vue";
// import SearchPage from "@/pages/search/FormPage.vue";
import SearchPage from "@/pages/search/StepFirst.vue";
import SearchResultPage from "@/pages/search/StepSecond.vue"

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: HomePage,
  },
  {
    path: "/rule/:name",
    name: "rule",
    component: RulePage,
  },
  {
    path: "/apply/:typeName",
    name: "apply",
    component: BusinessPage,
  },
  {
    path: "/result/:type",
    name: "resultPage",
    component: ResultPage,
  },
  {
    path: "/search/:name",
    name: "search",
    component: SearchPage,
  },
  {
    path: "/searchResult/:type",
    name: "searchResult",
    component: SearchResultPage,
  },
];

const router = new VueRouter({
  routes,
});

router.beforeEach((to, from, next) => {
  console.log(to.fullPath);


  next();
});

export default router;
